// prettier-ignore
export default "2025.0516.0936"